<template>
  <main class="home">
    <WithdrawInstructions
      :pendingWithdrawal="pendingWithdrawal"
      :instructionFieldsSetting="instructionFieldsSetting"
    />
  </main>
  <LoadingOverlay :loading="loading" />
</template>

<script setup lang="ts">
import { getCurrentInstance, onBeforeMount, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import WithdrawInstructions from "@/apps/credit-line/components/WithdrawInstructions.vue";
import LoadingOverlay from "@/shared-components/ui/core-app/LoadingOverlay.vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import {
  CreditLineDebitType,
  IWithdrawal,
  TransactionStatus,
} from "@/apps/credit-line/models/CreditLineDetails";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";
import { getSetting } from "@/apps/credit-line/helpers/consumerSettings.helper";
import { SettingsCategory } from "@/shared-models/consumer/SettingsCategory";

declare const Android: AndroidInterface;

const store = useStore();
const { fetchSummary } = useCreditLineSummary();
const pendingWithdrawal = ref({} as IWithdrawal);
const loading = ref<boolean>(false);

const instructionFieldsSetting = ref<string[]>([]);

onMounted(async () => {
  loading.value = true;
  try {
    const summary = await fetchSummary();
    if (summary) {
      const pendingWithdrawalInfo: IWithdrawal | undefined =
        summary.withdrawals.find(
          (e) =>
            (e.status === TransactionStatus.READY ||
              e.status === TransactionStatus.PENDING) &&
            e.type === CreditLineDebitType.WITHDRAWAL
        );
      if (pendingWithdrawalInfo) {
        pendingWithdrawal.value = pendingWithdrawalInfo;
        await store.dispatch(
          "creditLine/setPendingWithdrawal",
          pendingWithdrawal.value
        );
        if (Android.finishedLoading) {
          Android.finishedLoading();
        }
      }
    }

    const withdrawalFunnelSetting = await getSetting(
      "withdrawalFunnel",
      SettingsCategory.CL_WITHDRAWAL
    );

    instructionFieldsSetting.value =
      withdrawalFunnelSetting?.values?.pickupInstructionsFields ?? [];
  } finally {
    loading.value = false;
  }
});

onBeforeMount(() => {
  setLanguage(getCurrentInstance()?.proxy);
});
</script>
